import { OfferNetworkProvider } from "@redotech/crdb-enums/marketing/offer-network-provider";
import { offerPlacementSummarySchema } from "@redotech/order-tracking-common/offer-network/offer-placement";
import { OfferPlacementSurface } from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createOfferPlacement = {
  name: "createOfferPlacement" as const,
  input: z.discriminatedUnion("provider", [
    z.object({
      provider: z.literal(OfferNetworkProvider.Falcon),
      name: z.string().min(1),
      surface: createEnum(Object.values(OfferPlacementSurface)),
      isLiveMode: z.boolean().default(true),
    }),
    z.object({
      provider: z.literal(OfferNetworkProvider.Rokt),
      name: z.string().min(1),
      surface: createEnum(Object.values(OfferPlacementSurface)),
      pageIdentifier: z.string().min(1),
      sandbox: z.boolean(),
    }),
    // Uptick takes no per-placement settings: its place comes from the surface
    // and its appExternalId is minted server-side.
    z.object({
      provider: z.literal(OfferNetworkProvider.Uptick),
      name: z.string().min(1),
      surface: createEnum(Object.values(OfferPlacementSurface)),
    }),
    // Disco takes no per-placement settings: the widget page type and format
    // come from the surface and the widget is created on Disco's side.
    z.object({
      provider: z.literal(OfferNetworkProvider.Disco),
      name: z.string().min(1),
      surface: createEnum(Object.values(OfferPlacementSurface)),
    }),
  ]),
  output: z.object({ placement: offerPlacementSummarySchema }),
};
